import {ChoiceGroup} from '@fluentui/react';
import React, { useEffect, useState } from "react";
import Warning from '../../CreateSite/CommonComponents/Warning';

const CustomRadioButton = ({defaultValue, value, options, onUpdate, disabled, isreadonly, onValidation, required, errorMessage, warningMessage, additionalIcon}) => {

    const [newValue, setNewValue] = useState(defaultValue !== undefined && defaultValue !== null ? defaultValue.toString() : defaultValue);

    useEffect(() => {
        if (value !== undefined)
            setNewValue(value)
    }, [value])

    useEffect(() => {
        if (onValidation && required) 
            onValidation(isValid())
    }, [newValue, errorMessage])

    const isValid = () => {
        return !!newValue && !errorMessage
    }

    const onChange = (e, v) => {
        setNewValue(v.key)

        const key = v.key === 'true'
                    ? true
                    : v.key === 'false'
                        ? false
                        : v.key

        const value = required ? key : { value: key }
        onUpdate(value)
    }

    // const getDefaultSelectedKey = (value) => {
    //     if (value)
    //         return options.find(x => x.text === value).key
    // }

    const optionalOptions: IChoiceGroupOption[] = [
        { key: null, text: '' },
        ...options
    ];

    const warning = required && !isValid()
                    ? <Warning element='nolabel-small' title={!errorMessage ? 'Field cannot be empty.' : ''} />
                    : null;

    return (
        <div style={{width:'100%', position:'relative'}}>
            <div>
                <ChoiceGroup
                    onChange={onChange}
                    disabled={disabled || isreadonly}
                    selectedKey={newValue}
                    options={required ? options : optionalOptions}
                    errorMessage={errorMessage}
                />
                {warning}
                <div className='absoluteIcon warning-nolabel-dropdown'>
                    {additionalIcon}
                </div>    
                {
                    !errorMessage && warningMessage &&
                    <div className='warningMessage'>
                        { warningMessage }
                    </div> 
                }
            </div>
        </div>
    );
}

// const dropdownStyles = {
//     dropdownItem: { 
//         height: 'auto' 
//     },
//     dropdownItemSelected: {
//         height: 'auto',
//     },
//     dropdownOptionText: {
//         whiteSpace: 'normal',
//     }
// };

export default CustomRadioButton


// WEBPACK FOOTER //
// ./src/components/EditSite/SiteEditElements/CustomRadioButton.js